import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_CHOOSING_SURNAME {
  Nessuno = '0',
  Art131 = '1',
  Art218 = '2',
  Altro = '3',
}

export enum VALUES_CHOOSING_SURNAME {
  Nessuno = 'Nessuno',
  Art131 = 'ai sensi della sentenza n.131 del 27/04/2022 Corte cost.',
  Art218 = 'ai sensi della legge 218 del 31/05/1995',
  Altro = 'Altro specificare',
}

const choosingData: Array<ItemVM> = [
  {
    id: ID_CHOOSING_SURNAME.Art131,
    value: VALUES_CHOOSING_SURNAME.Art131,
  },
  {
    id: ID_CHOOSING_SURNAME.Art218,
    value: VALUES_CHOOSING_SURNAME.Art218,
  },
  {
    id: ID_CHOOSING_SURNAME.Altro,
    value: VALUES_CHOOSING_SURNAME.Altro,
  },
];

interface ListReasonChoosingSurnameProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value?: ItemVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
}

const ListReasonChoosingSurnameComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
}: ListReasonChoosingSurnameProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="choosing-label">
        {required ? 'Lista motivo scelta cognome *' : 'Lista motivo scelta cognome'}
      </InputLabel>
      <PmiSelect
        labelId="choosing-label"
        id="choosing"
        name="choosing"
        value={value}
        label={required ? 'Lista motivo scelta cognome *' : 'Lista motivo scelta cognome'}
        onChange={(event) => onChange(choosingData?.find((item) => item.id === event.target.value))}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {choosingData?.map((choosing: ItemVM) => (
          <MenuItem key={choosing.id} value={choosing.id}>
            {choosing.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListReasonChoosingSurnameComponent.displayName = 'List Reason Choosing Surname component';

const ListReasonChoosingSurname = memo(ListReasonChoosingSurnameComponent);

export default ListReasonChoosingSurname as typeof ListReasonChoosingSurnameComponent;
